<template>
  <div>
    <card>
      <b-container fluid="lg">

        <b-row>
          <b-col>
            <b-button block v-b-modal.modal-AddNode
                      variant="primary">Add Ysy Node
            </b-button>
          </b-col>
        </b-row>

        <b-row class="top-buffer-node">
          <b-col>
            <b-button block v-b-modal.modal-CancelMyNodes @click="LoadYsyUserNodes"
                      variant="primary">Cancel my nodes
            </b-button>
          </b-col>
        </b-row>
        <b-row class="top-buffer-node">
          <b-col>
            <b-button block v-b-modal.modal-ShowNodes @click="LoadYsyUserNodes"
                      variant="primary">Show my nodes
            </b-button>
          </b-col>
        </b-row>
        <b-row class="top-buffer-node">
          <b-col>
            <b-button block v-b-modal.modal-JoinNodes @click="LoadYsyNodesSubject"
                      variant="primary">Join a node
            </b-button>
          </b-col>
        </b-row>

      </b-container>
    </card>
    <b-modal id="modal-AddNode" header-bg-variant='light'
             header-text-variant="light"
             @ok="SubmitYsyNodes"
             title="YourSynchronicity Node Growth"
             ok-title="Add"
             no-close-on-backdrop
             cancel-title="close"
    >

      <p>Create your node configuration</p>
      <label for="nodeName">Name your node</label>
      <input v-model="ysyUserNode.ysyNodeName" type="text"
             placeholder=''
             id="nodeName" class="form-control form-control" height="100%">
      <label for="nodeLinkedinPost">The post to add to your node:</label>
      <input v-model="ysyUserNode.ysyPostUrl" type="text"
             placeholder=''
             id="nodeLinkedinPost" class="form-control form-control" height="100%">

      <label class="typo__label">Choose the subject linked to your post</label>
      <multiselect v-model="ysyUserNode.ysyUserNodeValueSubject" :options="optionYsyNodesSubjectsForPost"
                   :multiple="true"
                   :clear-on-select="false" :preserve-search="true" placeholder="Pick some" label="name"
                   track-by="name" :preselect-first="false">
        <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single"
                                                                                 v-if="values.length && !isOpen">{{
            values.length
          }} options selected</span></template>
      </multiselect>
      <template v-for="subjects in ysyUserNode.ysyUserNodeValueSubject">
        <span>"{{ subjects.name }}"</span>&#32;
        <slot></slot>
      </template>
    </b-modal>
    <b-modal id="modal-ShowNodes" header-bg-variant='light'
             header-text-variant="light"
             title="YourSynchronicity Node Growth"
             ok-only>
      <label class="typo__label">Your nodes</label>
      <multiselect v-model="valueNodeDisplay" track-by="name" label="name" placeholder="Select one"
                   :options="ysyUserNodeSub" :allow-empty="false">
        <!--        <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.name }}</strong> is written in<strong>-->
        <!--          {{ option.language }}</strong></template>-->

      </multiselect>
      <pre class="language-json"><code>{{ valueNodeDisplay }}</code></pre>


    </b-modal>
    <b-modal id="modal-CancelMyNodes" header-bg-variant='light'
             header-text-variant="light"
             title="YourSynchronicity Node Growth"
             @ok="UnsubscribeYsyNodes"
             ok-title="unsubscribe node"
             ok-only>
      <label class="typo__label">Your nodes</label>
      <multiselect v-model="ysyUserNodesUnsubscribe" track-by="name" label="name" :multiple="true"
                   placeholder="Select the node to unsubscribe"
                   :options="ysyUserNodeSub" :allow-empty="true">
        <!--        <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.name }}</strong> is written in<strong>-->
        <!--          {{ option.language }}</strong></template>-->
      </multiselect>
      <pre class="language-json"><code>{{ ysyUserNodesUnsubscribe }}</code></pre>


    </b-modal>
    <b-modal id="modal-JoinNodes" header-bg-variant='light'
             header-text-variant="light"
             title="YourSynchronicity Node Growth"
             no-close-on-backdrop
             @ok="JoinNodeYsy"
             ok-title="Join"
             ok-only>
      <label class="typo__label">YourSynchronicity Available nodes</label>
      <multiselect v-model="ysyUserNodesJoin" track-by="name" label="name" placeholder="Select the nodes to join"
                   :multiple="true"
                   :options="optionYsyNodesSubjects" :allow-empty="false">
        <!--        <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.name }}</strong> is written in<strong>-->
        <!--          {{ option.language }}</strong></template>-->
      </multiselect>
      <tags-input v-model="ysyUserNodesJoinComments" placeholder="Add your comments"></tags-input>

    </b-modal>
  </div>

</template>

<script>
import {refreshIdToken} from '@/util/utilsYsy'
import Multiselect from 'vue-multiselect'
import Tab from "@/components/Argon/Tabs/Tab";
import Tabs from "@/components/Argon/Tabs/Tabs";
import TagsInput from '../Argon/Inputs/TagsInput'

export default {
  name: "AddNewYsyNodeLI",
  data() {
    return {
      ysyUserNode: {
        ysyPostUrl: '',
        ysyNodeName: '',
        ysyUserNodeValueSubject: []
      },
      ysyUserNodesJoin: [],
      ysyUserNodesJoinComments: [],
      valueNodeDisplay: '',
      ysyUserNodesUnsubscribe: [],
      optionsYsyPods: [],
      optionYsyNodesSubjects: [],
      optionYsyNodesSubjectsForPost: [],
      selectedReusableTemplateForPods: '',
      ysyUserTmpTemplatePod: '',
      ysyUserNodeSub: [],
    };
  },
  components: {
    Multiselect,
    'tab-pane': Tab,
    TagsInput,
    Tabs,
  },
  methods: {
    refreshIdToken,
    async LoadYsyNodesSubjectAvailableForPost() {
      const path = this.BACKEND_YSY + "/linkedin/init-organic-state";
      let headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.id_token}`
      };
      const payload = {
        ysy_username: this.$store.getters.getUser,
        email_linkedin: this.$store.getters.getEmailLinkedin,
        action: "get_ysy_nodes"
      };
      console.log(payload);
      await this.$http
        .post(path, payload, {headers})
        .then(async res => {
          console.log('res', res)
          this.optionYsyNodesSubjectsForPost = res.data
        })
        .catch(async error => {
          const self = this;
          if (error.response.status === 401) {
            console.error('Unauthorized', error.response.data);
            await this.refreshIdToken().then(function (result) {
              console.log("res promise", result); // "Stuff worked!"
              self.Endorse()

            }, function (err) {
              console.log("it broke", err); // Error: "It broke"
              self.$router.push({name: 'login'});
            });
          }
        });

    },
    async LoadYsyNodesSubject() {
      const path = this.BACKEND_YSY + "/linkedin/init-organic-state";
      let headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.id_token}`
      };
      const payload = {
        ysy_username: this.$store.getters.getUser,
        email_linkedin: this.$store.getters.getEmailLinkedin,
        action: "get_list_nodes"
      };
      console.log(payload);
      await this.$http
        .post(path, payload, {headers})
        .then(async res => {
          console.log('res', res)
          this.optionYsyNodesSubjects = res.data
        })
        .catch(async error => {
          const self = this;
          if (error.response.status === 401) {
            console.error('Unauthorized', error.response.data);
            await this.refreshIdToken().then(function (result) {
              console.log("res promise", result); // "Stuff worked!"
              self.Endorse()

            }, function (err) {
              console.log("it broke", err); // Error: "It broke"
              self.$router.push({name: 'login'});
            });
          }
        });

    },
    async SubmitYsyNodes() {
      const path = this.BACKEND_YSY + "/linkedin/init-organic-state";
      let headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.id_token}`
      };
      const payload = {
        ysy_username: this.$store.getters.getUser,
        email_linkedin: this.$store.getters.getEmailLinkedin,
        node_name: this.ysyUserNode.ysyNodeName,
        join_ysy_nodes_name: this.ysyUserNode.ysyUserNodeValueSubject,
        post_url: this.ysyUserNode.ysyPostUrl,
        expiration_time: 1,
        action: "add_node"
      };
      console.log(payload);
      await this.$http
        .post(path, payload, {headers})
        .then(async res => {
          console.log('res', res)
          this.ysyUserNode = {
            ysyPostUrl: '',
            ysyNodeName: '',
            ysyUserNodeValueSubject: []
          }
        })
        .catch(async error => {
          const self = this;
          console.log('error', error)
          if (error.response.status === 401) {
            console.error('Unauthorized', error.response.data);
            await this.refreshIdToken().then(function (result) {
              console.log("res promise", result); // "Stuff worked!"
              self.Endorse()

            }, function (err) {
              console.log("it broke", err); // Error: "It broke"
              self.$router.push({name: 'login'});
            });
          }
        });

    },
    async UnsubscribeYsyNodes() {
      const path = this.BACKEND_YSY + "/linkedin/init-organic-state";
      let headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.id_token}`
      };
      const payload = {
        ysy_username: this.$store.getters.getUser,
        email_linkedin: this.$store.getters.getEmailLinkedin,
        nodes_name: this.ysyUserNodesUnsubscribe,
        action: "unsubscribe_node"
      };
      console.log(payload);
      await this.$http
        .post(path, payload, {headers})
        .then(async res => {
          console.log('res', res)
          this.ysyUserNodesUnsubscribe = []
        })
        .catch(async error => {
          const self = this;
          console.log('error', error)
          if (error.response.status === 401) {
            console.error('Unauthorized', error.response.data);
            await this.refreshIdToken().then(function (result) {
              console.log("res promise", result); // "Stuff worked!"
              self.Endorse()

            }, function (err) {
              console.log("it broke", err); // Error: "It broke"
              self.$router.push({name: 'login'});
            });
          }
        });

    },
    async JoinNodeYsy() {
      const path = this.BACKEND_YSY + "/linkedin/init-organic-state";
      let headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.id_token}`
      };
      const payload = {
        ysy_username: this.$store.getters.getUser,
        email_linkedin: this.$store.getters.getEmailLinkedin,
        nodes_name: this.ysyUserNodesJoin,
        comments: this.ysyUserNodesJoinComments,
        action: "subscribe_node"
      };
      console.log(payload);
      await this.$http
        .post(path, payload, {headers})
        .then(async res => {
          console.log('res', res)
          this.ysyUserNodesJoin = []
          this.ysyUserNodesJoinComments = []
        })
        .catch(async error => {
          const self = this;
          console.log('error', error)
          if (error.response.status === 401) {
            console.error('Unauthorized', error.response.data);
            await this.refreshIdToken().then(function (result) {
              console.log("res promise", result); // "Stuff worked!"
              self.Endorse()

            }, function (err) {
              console.log("it broke", err); // Error: "It broke"
              self.$router.push({name: 'login'});
            });
          }
        });

    },
    async LoadYsyUserNodes() {
      this.LoadYsyNodesSubject()
      const path = this.BACKEND_YSY + "/linkedin/init-organic-state";
      let headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.id_token}`
      };
      const payload = {
        ysy_username: this.$store.getters.getUser,
        email_linkedin: this.$store.getters.getEmailLinkedin,
        action: "show_nodes"
      };
      console.log(payload);
      await this.$http
        .post(path, payload, {headers})
        .then(async res => {
          console.log('res', res)
          this.ysyUserNodeSub = res.data
        })
        .catch(async error => {
          const self = this;
          console.log('error', error)
          if (error.response.status === 401) {
            console.error('Unauthorized', error.response.data);
            await this.refreshIdToken().then(function (result) {
              console.log("res promise", result); // "Stuff worked!"
              self.Endorse()

            }, function (err) {
              console.log("it broke", err); // Error: "It broke"
              self.$router.push({name: 'login'});
            });
          }
        });

    }
  },
  created() {
    this.LoadYsyNodesSubjectAvailableForPost()
    this.LoadYsyUserNodes()
  },

}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>

.top-buffer-node {
  margin-top: 5% !important;
}
</style>
